<template>
  <div
    class="[&_h1]:text-26 [&_h1]:md:text-28 [&_h1]:lg:text-39 [&_h1]:xl:text-54 relative overflow-hidden py-60 text-white md:py-130 md:pl-100 xl:py-160 xl:pl-160 [&_h1]:leading-none [&_h1]:font-bold"
  >
    <AppImage
      :name="image"
      :alt="alt"
      sizes="100vw"
      eager
      preload
      img-class="absolute inset-0 z-0 h-full w-full object-cover"
    />
    <div class="relative z-10 container">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import AppImage from '@/components/shared/AppImage.vue';

/// Setup
defineProps({
  image: { type: String, required: true },
  alt: { type: String, required: true },
});
</script>
